export const stacksViewSx = {
  viewModal: {
    titleWrapper: {
      bgcolor: 'rgb(48 51 57)',
      p: 2,
    },
    closeButtonWrapper: {
      display: 'flex',
      justifyContent: 'right',
    },
  },
  view: {
    titles: {
      control: {
        fontSize: '1.4rem',
        fontWeight: 600,
        textAlign: 'center',
      },
      stack: {
        fontSize: '1.4rem',
        fontWeight: 600,
        textAlign: 'center',
      },
      noModes: {
        fontSize: '1.4rem',
        fontWeight: 600,
        textAlign: 'center',
      },
    },
    controlModesAuthority: {
      wrapper: {
        border: '1px solid rgb(80 85 89)',
        background: '#212327',
        p: 4,
        flex: 1,
        authorityWrapper: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexBasis: '50%',
          flex: 1,
          textAlign: 'left',
        },
        authorityTitle: {
          fontSize: '1.2rem',
          fontWeight: 600,
          '@media (min-width: 1536px)': {
            fontSize: '1.5rem',
          },
        },
        buttonGroup: {
          flexBasis: '50%',
          justifyContent: 'center',
          display: 'flex',
          button: {
            width: 125,
            height: 50,
            '@media (min-width: 1920px)': {
              width: 250,
              height: 60,
              fontSize: '1.2rem',
            },
          },
        },
      },
    },
  },
};
